import {
  getPutApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdMutationFetcher,
  getPutApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdMutationKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import { useMutation } from '@fukuri-admins/hooks/common';
import { type AxiosError } from 'axios';

/**
 * 企業管理者更新フック
 */
export const usePutClientAdminUser = (
  threeLetterCode: string,
  clientAdminUserId: number,
  options?: {
    onSuccess?: () => void;
    onError?: (error: AxiosError<{ errors?: string[] }>) => void;
  }
) =>
  useMutation(
    getPutApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdMutationKey(
      threeLetterCode,
      clientAdminUserId
    ),
    getPutApiV1ThreeLetterCodeClientAdminsClientAdminUsersIdMutationFetcher(
      threeLetterCode,
      clientAdminUserId
    ),
    options
  );
